import React, { useState, useEffect } from 'react';
import styles from '../../../../styles/PerformanceDashboard.module.css';

interface FloatingNavProps {
  sections: Array<{
    id: string;
    label: string;
    icon: React.ReactNode;
  }>;
  activeSection: string;
  onSectionChange: (sectionId: string) => void;
}

const FloatingNav: React.FC<FloatingNavProps> = ({ sections, activeSection, onSectionChange }) => {
  return (
    <nav className={styles.floatingNav}>
      <ul className={styles.floatingNavList}>
        {sections.map((section) => (
          <li key={section.id}>
            <button
              className={`${styles.floatingNavItem} ${activeSection === section.id ? styles.active : ''
                }`}
              onClick={() => onSectionChange(section.id)}
              data-tooltip={section.label}
            >
              <span className={styles.floatingNavIcon}>{section.icon}</span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default FloatingNav;

